var _defs, _path, _path2, _path3, _circle, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCavernicolaCreativoFlame({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "creativeFire",
    x1: 96,
    y1: 430,
    x2: 410,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F72585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF5A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD166"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "softGlow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M276 44C277 112 223 141 237 205C247 181 267 164 299 151C294 187 338 208 359 247C373 274 378 307 369 340C352 407 302 455 237 458C164 461 108 410 103 339C98 278 133 238 170 201C197 174 216 142 211 103C263 130 284 170 279 212C311 171 309 107 276 44Z",
    fill: "url(#creativeFire)",
    filter: "url(#softGlow)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M238 246C255 281 228 301 237 332C248 317 264 308 283 307C278 328 299 343 298 372C297 407 271 432 237 432C201 432 176 406 177 372C178 340 197 324 212 309C227 294 236 275 238 246Z",
    fill: "#111827"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M189 218L213 205L210 231L189 218Z",
    fill: "#111827",
    fillOpacity: 0.94
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 184,
    cy: 215,
    r: 7,
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M166 181L196 199",
    stroke: "#111827",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M152 201L184 209",
    stroke: "#111827",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M163 229L190 218",
    stroke: "#111827",
    strokeWidth: 12,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCavernicolaCreativoFlame);
export default __webpack_public_path__ + "static/media/cavernicola-creativo-flame.7959b5faca3266ff50087ab2e92d7083.svg";
export { ForwardRef as ReactComponent };